export default "__VITE_ASSET__C$nC0IVs__"